import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Grid from '../Base/AntGrid';
import { fetchServer } from '../Base/modelManager';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';
import PaiementForm from './PaiementForm';
import { message } from 'antd';




class Factures extends React.Component {
  constructor(props) {
    super(props)

    const actions = []


    this.state = {
      data: [],
      columns: [],
      loading: false,
      keyField: '',
      queryColumns: [],
      height: 0,
      quickFilterString: '',
      actions: actions,
      render: true,
      selectedRows: [],
      modal: {
        isOpen: false,
        view: null,
        record: null,
      },
      filters: {},
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
      }

    }
  }

  componentDidMount() {
    this.handleFetch()
  }


  componentDidUpdate(prevProp) {
    if (prevProp.currentClient !== this.props.currentClient)
      this.handleFetch()
  }


  showModal = (record) => {
    this.setState(
      {
        modal: {
          isOpen: true,
          record: record
        }
      }
    )
  }

  getModalComponent = () => {
    const { isOpen, record } = this.state.modal
    if (isOpen === true) {

      return (
        <Modal show={isOpen} >
          {
            <PaiementForm envID={this.props.url} facture={record} {...this.props} onCancel={this.onPaiementCanceled} />
          }

        </Modal>
      )
    }
    else return null
  }

  onPaiementCanceled = () => {
    this.setState(
      {
        modal: {
          isOpen: false,
          record: null
        }
      }
    )
  }

  printFacture = (factureid) => {
    /*    var details = {
            'id': factureid,
            'forcetout': true,
            'details': true,
            'facture': true
    
        };
    */

    const url = this.props.apiUrl + '/Services/getFacturePdf'//?factureid=' + factureid
    fetch(url, {
      method: 'POST',
      body: JSON.stringify({ factureid: factureid }),
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.props.JWTToken
      },
    })
      .then(response => {
        if (response.status === 200) {
          response.blob().then(blob => {
            const url = window.URL.createObjectURL(
              new Blob([blob])
            )

            //window.open(url)
            const a = document.createElement('a')
            a.href = url
            a.download = 'facture.pdf'
            a.target = '_blank'
            a.rel = 'noopener noreferrer'
            document.body.appendChild(a);
            a.click()
            a.parentNode.removeChild(a);
          })
        } else {
          message.error('Erreur lors de la génération des factures');
        }

      })

  }

  ExcelFacture = (factureid) => {
    /*    var details = {
            'id': factureid,
            'forcetout': true,
            'details': true,
            'facture': true
    
        };
    */

    const url = this.props.apiUrl + '/Services/getFactureXls'//?factureid=' + factureid
    fetch(url, {
      method: 'POST',
      body: JSON.stringify({ factureid: factureid }),
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.props.JWTToken
      },
    })
      .then(response => {
        if (response.status === 200) {
          response.blob().then(blob => {
            const url = window.URL.createObjectURL(
              new Blob([blob])
            )

            //window.open(url)
            const a = document.createElement('a')
            a.href = url
            a.download = 'facture.xlsx'
            a.target = '_blank'
            a.rel = 'noopener noreferrer'
            document.body.appendChild(a);
            a.click()
            a.parentNode.removeChild(a);
          })
        } else {
          message.error('Erreur lors de la génération des factures');
        }

      })

  }

  columns = () => {
    const cols = []

    cols.push(

      {
        render: (text, row) => row.periode.libelle,
        title: 'Libellé',
        width: '350px'
      },
      {
        render: (text, row) => moment(row.date).format('DD/MM/YYYY'),
        title: 'Date',
        width: '150px'
      },
      {
        title: 'Montant HT',
        render: (text, row) => parseFloat(row.montantht).toFixed(2),
        width: '150px'
      },
      {
        title: 'Montant TVA',
        render: (text, row) => parseFloat(row.montanttva).toFixed(2),
        width: '150px'
      },
      {
        title: 'Montant TTC',
        render: (text, row) => parseFloat(row.montantht + row.montanttva + row.arrondi).toFixed(2),
        width: '150px'
      },
      {
        title: 'Solde',
        render: (text, row) => parseFloat(row.solde).toFixed(2),
        width: '150px'
      },
      {
        title: '',
        render: (text, row) => this.actionRenderer(row),
        with: '150px'
      }

    )
    return cols
  }


  render() {

    return (
      <>
        {this.getModalComponent()}
        <Grid
          data={this.state.data}
          columns={this.columns()}
          pagination={this.state.pagination}
          loading={this.state.loading}
          keyField='id'
          handleFetch={this.handleFetch}
          actions={this.state.actions}
          title="- MES FACTURES -"
        />
      </>
    )


  }

  processFilter = (filters) => {
    let filter = ''

    const keys = Object.keys(filters)


    if (this.props.filter !== undefined) {
      filter = 'client/uid eq ' + this.props.filter.cid
    }

    keys.forEach(key => {
      if (filters[key] !== null) {
        switch (key) {
          case 'client': {
            if (this.props.filter === undefined) {
              if (filter !== '') filter = filter + ' and '
              filter = filter + ' client/uid eq ' + filters[key]

            }
            break
          }
          case 'numfacture': {
            filter.numclient = filters[key]
            break
          }
          default: {
            filter[key] = filters[key][0]
          }
        }
      }


    })




    if (filter !== '')
      filter = '&$filter=' + filter

    return filter
  }

  onError = (error) => {
    message.error(error)
  }

  actionRenderer = (row) => {

    const actions = []
    actions.push(
      {
        id: 'print',
        icon: <img src="/assets/images/icons/printer.svg" alt="Bootstrap" width="16" height="16" />,
        tooltip: 'Télécharge ma facture au format PDF',
        onExecute: () => {
          this.printFacture(row.id)
        }
      })

    actions.push(
      {
        id: 'excel',
        icon: <img src="/assets/images/icons/filetype-xlsx.svg" alt="Bootstrap" width="16" height="16" />,
        tooltip: 'Exporter',
        onExecute: () => {
          this.ExcelFacture(row.id)
        }


      })
      
    if ((row.solde < 0) && ((this.props.url === 'btf' ))){
      
        actions.push(
          {
            id: 'Payer',
            icon: <img src="/assets/images/icons/credit-card-2-front.svg" alt="Bootstrap" width="16" height="16" />,
            tooltip: 'Payer',
            onExecute: () => {
              this.showModal(row)
            }
          }
        )


    }



    return (
      <span>
        {
          actions.map((action) => {
            const renderTooltip = (props) => (
              <Tooltip id={props.id}>
                {props.tooltip}
              </Tooltip>
            );
            return (
              <OverlayTrigger
                key={action.id}
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip(action)}
              >

                <Button bsPrefix="gridButton" onClick={(event) => { action.onExecute(event, row) }}> {action.icon}</Button>

              </OverlayTrigger>

            )
          })
        }
      </span>

    )
  }

  handleFetch = (pagination, filters, sorter) => {



    if (this.state.loading === false) {
      this.setState({ loading: true })

      if (pagination === undefined)
        pagination = this.state.pagination


      if (filters === undefined)
        filters = this.state.filters

      if (sorter === undefined)
        sorter = this.state.sorter


      const filter = this.processFilter(filters)

      // filter.page = page;
      // filter.pageSize = this.state.pageSize

      const request = {
        endPoint: this.props.apiUrl + '/Facture?$select=id,client/uid, client/numero, client/nom, periode/uid, numero, date, periode/libelle, montantht, montanttva, arrondi, solde, validated&$orderby=date desc&$expand=client, periode&$top=' + pagination.pageSize + '&$skip=' + pagination.pageSize * (pagination.current - 1) + '&$inlinecount=allpages' + filter,
        method: 'GET',
        token: this.props.JWTToken
      }

      fetchServer(request, (json) => {

        this.setState(({
          loading: false,
          data: json.value,
          pagination: {
            total: json['@xdata.count'],
            current: pagination.current,
            pageSize: pagination.pageSize
          },
          render: true,
          filters: filters

        }))
      }, this.onError)

    }
  }
}


const mapStateToProps = (state) => {
  return ({
    serverConfigLoaded: state.server.initialized,
    clients: state.authentication.clients,
    currentClient: state.authentication.currentClient,
    JWTToken: state.authentication.JWTToken,
    apiUrl: state.server.apiUrl,
    url: state.app.url
  })
}

Factures.propTypes = {
  dispatch: PropTypes.func,
  apiUrl: PropTypes.string,
  clients: PropTypes.array,
  currentClient: PropTypes.object,
  JWTToken: PropTypes.string,
  url: PropTypes.string
};

export default connect(mapStateToProps)(Factures);
